import { Stack, Typography } from "@mui/material";
import React from "react";
import SimpleIconAlert from "../../../components/display/SimpleIconAlert";
import Skeletons from "../../../components/loader/Skeletons";
import PendingAppointment from "../../admin/pendingAppointments/components/PendingAppointment";
export default function PendingAppointmentsHomePage({
  loading,
  error,
  refetch,
  appointments,
}) {
  if (loading) {
    return <Skeletons height={100} numOfSkeletons={9} grid={false} />;
  }
  if (error) {
    return <SimpleIconAlert message={"ErrorFetchingPendingAppointments"} />;
  }

  const renderCondition = appointments?.length < 1 && !loading;

  if (renderCondition) {
    return (
      <SimpleIconAlert message={"NoPendingAppointments"} severity="info" />
    );
  }

  return (
    <Stack spacing={2}>
      {appointments?.slice(0, 5).map((item) => (
        <PendingAppointment
          refetch={refetch}
          slimVersion={true}
          appointment={item}
          isStack={true}
        />
      ))}
    </Stack>
  );
}
